/**
 * @generated SignedSource<<88338721ca4024fc3e5d6472dfc3c332>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type parent_issueFieldParentReadviewFull_ParentReadView$data = {
  readonly hoverOrFocusState?: {
    readonly " $fragmentSpreads": FragmentRefs<"popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent">;
  } | null | undefined;
  readonly id?: string;
  readonly parentIssue: {
    readonly issueColorField: {
      readonly color: {
        readonly colorKey: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly issueTypeField: {
      readonly issueType: {
        readonly avatar: {
          readonly xsmall: string | null | undefined;
        } | null | undefined;
        readonly name: string;
      } | null | undefined;
    } | null | undefined;
    readonly key: string;
    readonly summaryField: {
      readonly text: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "parent_issueFieldParentReadviewFull_ParentReadView";
};
export type parent_issueFieldParentReadviewFull_ParentReadView$key = {
  readonly " $data"?: parent_issueFieldParentReadviewFull_ParentReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"parent_issueFieldParentReadviewFull_ParentReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "parent_issueFieldParentReadviewFull_ParentReadView",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "concreteType": "JiraFieldHoverOrFocusState",
              "kind": "LinkedField",
              "name": "hoverOrFocusState",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "concreteType": "JiraColorField",
          "kind": "LinkedField",
          "name": "issueColorField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraColor",
              "kind": "LinkedField",
              "name": "color",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "colorKey"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "xsmall"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "name"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "JiraSingleLineTextField",
          "kind": "LinkedField",
          "name": "summaryField",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "text"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraParentIssueField"
};

(node as any).hash = "2bf224c638811bcbfb67a5648355dc1a";

export default node;
